var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AE56F8FC-4CC6-4501-822E-E8ADD851F052") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders-List-In-Transit-Copy-10",
    transform: "translate(-88.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Item-Copy-3-Row-Item-v2",
    transform: "translate(64.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InTransit-In-Transit",
    transform: "translate(22.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    fill: "#0091EA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/pfj-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C6.26826667,0 0,6.32094118 0,14.1176471 C0,25.4117647 14,32 14,32 C14,32 28,25.4117647 28,14.1176471 C28,6.32094118 21.7317333,0 14,0",
    id: "Fill-1"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14,
    cy: 14,
    r: 11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.4545455,11.8125 L17.4090909,11.8125 L17.4090909,9 L7.86363636,9 C7.11363636,9 6.5,9.6328125 6.5,10.40625 L6.5,18.140625 L7.86363636,18.140625 C7.86363636,19.3078125 8.77727273,20.25 9.90909091,20.25 C11.0409091,20.25 11.9545455,19.3078125 11.9545455,18.140625 L16.0454545,18.140625 C16.0454545,19.3078125 16.9590909,20.25 18.0909091,20.25 C19.2227273,20.25 20.1363636,19.3078125 20.1363636,18.140625 L21.5,18.140625 L21.5,14.625 L19.4545455,11.8125 L19.4545455,11.8125 Z M9.90909101,19.1953125 C9.34318186,19.1953125 8.88636364,18.7242188 8.88636364,18.140625 C8.88636364,17.5570313 9.34318186,17.0859375 9.90909101,17.0859375 C10.4750002,17.0859375 10.9318184,17.5570313 10.9318184,18.140625 C10.9318184,18.7242188 10.4750002,19.1953125 9.90909101,19.1953125 L9.90909101,19.1953125 Z M19.1136362,12.8671875 L20.4499997,14.625 L17.4090909,14.625 L17.4090909,12.8671875 L19.1136362,12.8671875 L19.1136362,12.8671875 Z M18.0909092,19.1953125 C17.525,19.1953125 17.0681818,18.7242188 17.0681818,18.140625 C17.0681818,17.5570313 17.525,17.0859375 18.0909092,17.0859375 C18.6568183,17.0859375 19.1136366,17.5570313 19.1136366,18.140625 C19.1136366,18.7242188 18.6568183,19.1953125 18.0909092,19.1953125 L18.0909092,19.1953125 Z",
    id: "icon",
    fillOpacity: 0.85,
    fill: "#000000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransit);
export default __webpack_public_path__ + "static/media/InTransit.f388be6f65f898a98f8ab86efe9c6d26.svg";
export { ForwardRef as ReactComponent };